import { Component, OnDestroy, OnInit } from '@angular/core';
import { ComponentBase } from 'src/app/main/dynamic/component-base';
import { Subscription } from 'rxjs';
import { ProcessService } from 'src/app/service/process.service';
import { DynamicEvent } from 'src/app/main/dynamic/dynamic.event';

@Component({
  selector: 'app-select-multiple',
  templateUrl: './select-multiple.component.html',
  styleUrls: ['./select-multiple.component.scss']
})
export class SelectMultipleComponent extends ComponentBase implements OnInit, OnDestroy {

  items: Item[];
  selectedItems: Item[] = [];
  loadingSubscription: Subscription;

  constructor(private processService: ProcessService) {
    super()
    
    this.loadingSubscription = this.processService.getLoadingNotification().subscribe(isLoaded => {
      if (isLoaded) {
        this.loadSelectedItems()
      }
    });
  }

  ngOnInit() {
    this.loadSelectedItems()
  }

  ngOnDestroy() {
    this.loadingSubscription.unsubscribe()
  }

  private loadSelectedItems() {
    this.selectedItems = [];

    this.items = this.attribute
                     .attributes
                     .filter(a => a.type.toLowerCase() == "option")
                     .map(a => new Item(a.key, a.value));
    
    let selectedValues = this.attribute.value ? this.attribute.value.split(',') : [];

    selectedValues.forEach(key => {
      let foundItem = this.items.find(i => i.Key == key)

      if(foundItem) {
        this.selectedItems.push(foundItem);
      }
    });
  }

  changedSelection() {
    this.attribute.value = this.selectedItems.map(i => i.Key).join(",");

    let events: DynamicEvent[] = []
    
    if(this.attribute.hasError && this.attribute.value) {
      this.attribute.hasError = false
      events.push({ name: "validate" } )
    }

    events.push({ name: "autosave", data: "silently" })

    this.emitEvents(events)
  }
}

class Item {

  constructor(public Key: string, public Value: string){
    
  }
}
